import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  miniSidenav: false,
  transparentSidenav: true,
  sidenavColor: "warning",
  transparentNavbar: true,
  fixedNavbar: false,
  openConfigurator: false,
  direction: "ltr",
  layout: "dashboard",
};

export const UIControllerSlice = createSlice({
  initialState,
  name: "ui-controller-slice",
  reducers: {
    updateUI: (state, { payload }) => {
      return {
        ...state,
        [payload.type]: payload.value,
      };
    },
  },
});

export const { updateUI } = UIControllerSlice.actions;

export default UIControllerSlice.reducer;
